import React from 'react';
import { List, Datagrid, Filter, BooleanField, TextField, TextInput } from 'react-admin';

const AttendanceResultDetailsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const AttendanceResultDetailsList = props => (
  <List filters={<AttendanceResultDetailsFilter />} {...props} exporter={false}>
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <BooleanField source="enabled" />
    </Datagrid>
</List>
);

export default AttendanceResultDetailsList
